const state = {
	menushow: true,
	pageLoading: false,
	catch_components:JSON.parse(sessionStorage.getItem('cache'))||[],
	// 禁止浏览器前进后退
	forbid_back: false
}

const mutations = {
	SET_MENU: (state) =>{
		state.menushow = !state.menushow;
	},
	SHOWLOADING: (state) => {
		state.pageLoading = true;
	},
	HIDELOADING: (state) => {
		state.pageLoading = false;
	},
	SET_CACHE: (state,val) =>{
		state.catch_components =val;
	},
	// 添加keepalive缓存
	addKeepAliveCache(state, val) {
		if (val == '/home') {
			return;
		}
		if (state.catch_components.indexOf(val) === -1) {
			state.catch_components.push(val);
		}
		sessionStorage.setItem('cache',JSON.stringify(state.catch_components))
	},
	// 删除keepalive缓存
	removeKeepAliveCache(state, val) {
		let cache = state.catch_components;
		for (let i = 0; i < cache.length; i++) {
			if (cache[i] === val) {
				cache.splice(i, 1);
			}
		}
		state.catch_components = cache;
		sessionStorage.setItem('cache',JSON.stringify(state.catch_components))
	},
	// 禁止浏览器前进后退
	SET_FORBID_BACK(state, val) {
		state.forbid_back = val;
	}
}

const actions = {

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
